import React from 'react';
import Image from 'next/image';
import addNext from '../../svgs/plus_icon.svg';
import addNextN400 from '../../svgs/plus_icon_n400.svg';
import { NextImageProps } from '../NextImageProps';

type ExtendedNextImageProps = NextImageProps & {
  color?: 'black' | 'neutral-400';
};
export function AddNext({ className, width, height, alt, color }: ExtendedNextImageProps) {
  let imageSrc = addNext;
  if (color) {
    switch (color) {
      case 'black':
        imageSrc = addNext;
        break;
      case 'neutral-400':
        imageSrc = addNextN400;
        break;
      default:
        break;
    }
  }
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={imageSrc}
      alt={alt ?? 'Tilføj'}
    />
  );
}
